// Tiny fetch wrapper around the backend's /api/settings endpoint.
// See backend/server.ts for the corresponding handler.

import type { Settings } from "../../../../backend/shared";

export async function fetchSettings(): Promise<Settings> {
  const res = await fetch("/api/settings", { cache: "no-store" });
  if (!res.ok) throw new Error(`fetchSettings: HTTP ${res.status}`);
  return (await res.json()) as Settings;
}

export async function putSettings(s: Settings): Promise<void> {
  const res = await fetch("/api/settings", {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(s),
  });
  if (!res.ok) throw new Error(`putSettings: HTTP ${res.status}`);
}
